// const padding = (start, end, n) => `${start.padEnd(n, '.')} ${end}`;
// const space = (n) => (&nbsp)
const desktopInnerWidth = window.innerWidth > 800;

const commonTableHeader = [
  { value: 'Instruments / Sounds / Memberships' },
  { value: desktopInnerWidth ? ' Core ($29.99/yr) ' : 'Core' },
  { value: desktopInnerWidth ? 'Pro ($99/yr)' : 'Pro' },
  { value: desktopInnerWidth ? 'Ultimate ($199/yr)' : 'Ult' },
  { value: desktopInnerWidth ? 'Lifetime Key' : 'LTK' },
];

export const ZENOLOGY_TABLE = [
  // eslint-disable-next-line no-useless-escape
  commonTableHeader,
  [{ value: 'ZENOLOGY' }, { value: true }, { value: true }, { value: true }, { value: false }],
  [{ value: 'ZENOLOGY FX' }, { value: true }, { value: true }, { value: true }, { value: false }],
  [{ value: 'ZENOLOGY Pro' }, { value: false }, { value: true }, { value: true }, { value: 229 }],
  [{ value: 'Model Expansions**' }, { value: false }, { value: true }, { value: true }, { value: '$149.00 Each' }],
  [{ value: 'Sound Packs **(Model Expansions)' }, { value: false }, { value: true }, { value: true }, { value: '$19.99 Each' }],
  [{ value: 'Sound Packs **(SDZ)' }, { value: true }, { value: true }, { value: true }, { value: '$0.99 Each' }],
  [{ value: 'Wave Expansions **(EXZ)' }, { value: true }, { value: true }, { value: true }, { value: '$19.99 Each' }],
];

export const VIRTUAL_INSTRUMENTS_TABLE = [
  commonTableHeader,
  [{ value: 'Roland Cloud Concerto' }, { value: false }, { value: true }, { value: true }, { value: false }],
  [{ value: 'Drum Studio - Acoustic One' }, { value: false }, { value: true }, { value: true }, { value: false }],
  [{ value: 'Tera Collection: 2 titles' }, { value: false }, { value: true }, { value: true }, { value: false }],
  [{ value: 'FLAVR Collection: 9 titles' }, { value: false }, { value: true }, { value: true }, { value: false }],
  [{ value: 'Anthology Collection: 7 titles' }, { value: false }, { value: true }, { value: true }, { value: false }],
  [{ value: 'JD-800' }, { value: false }, { value: 'o*' }, { value: true }, { value: 149 }],
  [{ value: 'D-50' }, { value: false }, { value: 'o*' }, { value: true }, { value: 149 }],
  [{ value: 'TR-808' }, { value: false }, { value: 'o*' }, { value: true }, { value: 149 }],
  [{ value: 'TR-707' }, { value: false }, { value: 'o*' }, { value: true }, { value: 149 }],
  [{ value: 'TR-727' }, { value: false }, { value: 'o*' }, { value: true }, { value: 149 }],
  [{ value: 'JUNO-60' }, { value: false }, { value: 'o*' }, { value: true }, { value: 149 }],
  [{ value: 'TR-606' }, { value: false }, { value: 'o*' }, { value: true }, { value: 149 }],
  [{ value: 'JUNO-106' }, { value: false }, { value: 'o*' }, { value: true }, { value: 149 }],
  [{ value: 'JUPITER-8' }, { value: false }, { value: 'o*' }, { value: true }, { value: 149 }],
  [{ value: 'TR-909' }, { value: false }, { value: 'o*' }, { value: true }, { value: 149 }],
  [{ value: 'JX-3P' }, { value: false }, { value: 'o*' }, { value: true }, { value: 129 }],
  [{ value: 'TB-303' }, { value: false }, { value: 'o*' }, { value: true }, { value: 149 }],
  [{ value: 'JV-1080' }, { value: false }, { value: 'o*' }, { value: true }, { value: 129 }],
  [{ value: 'XV-5080' }, { value: false }, { value: 'o*' }, { value: true }, { value: 129 }],
  [{ value: 'System-8' }, { value: false }, { value: 'o*' }, { value: true }, { value: 129 }],
  [{ value: 'System-1' }, { value: false }, { value: 'o*' }, { value: true }, { value: 99 }],
  [{ value: 'Promars' }, { value: false }, { value: 'o*' }, { value: true }, { value: 99 }],
  [{ value: 'SH-101' }, { value: false }, { value: 'o*' }, { value: true }, { value: 99 }],
  [{ value: 'SH-2' }, { value: false }, { value: 'o*' }, { value: true }, { value: 99 }],
  [{ value: 'System-100' }, { value: false }, { value: 'o*' }, { value: true }, { value: 129 }],
  [{ value: 'Sound Canvas' }, { value: false }, { value: 'o*' }, { value: true }, { value: 69 }],
  [{ value: 'SRX Collection: 10 titles' }, { value: false }, { value: false }, { value: true }, { value: '$69.00 Each' }],
];

export const SOFTWARE_EFFECTS = [
  commonTableHeader,
  [{ value: 'ZENOLOGY FX' }, { value: true }, { value: true }, { value: true }, { value: false }],
  [{ value: 'JUNO-60 Chorus' }, { value: false }, { value: false }, { value: true }, { value: 99 }],
];

export const PATCHES_TABLE = [
  commonTableHeader,
  // [{ value: 'Zenbeats Ultimate Unlock' }, { value: true }, { value: true }, { value: true }, { value: '$150 In App Purchase' }],
  [{ value: 'All titles' }, { value: false }, { value: true }, { value: true }, { value: '$19.99 Each' }]];

export const JAM_TRACKS_TABLE = [
  commonTableHeader,
  [{ value: 'All titles' }, { value: false }, { value: true }, { value: true }, { value: '$14.99 Each' }]];

export const SAMPLE_CONTENT_TABLE = [
  commonTableHeader,
  [{ value: 'All titles' }, { value: false }, { value: true }, { value: true }, { value: '$19.99 Each' }]];

export const SOLUTIONS_TABLE = [
  commonTableHeader,
  [{ value: 'Zenbeats Max Unlock' }, { value: true }, { value: true }, { value: true }, { value: false }],
  [{ value: 'Zentracker' }, { value: true }, { value: true }, { value: true }, { value: false }],
  [{ value: 'Beat Sync Maker' }, { value: true }, { value: true }, { value: true }, { value: false }],
  [{ value: '4xCamera' }, { value: true }, { value: true }, { value: true }, { value: false }],
  [{ value: '4xCamera Maker' }, { value: true }, { value: true }, { value: true }, { value: false }],
  [{ value: 'R-MIX (Windows)' }, { value: false }, { value: false }, { value: true }, { value: false }]];

export const MODEL_EXPANSIONS_TABLE = [
  [{ value: 'Instruments / Sounds / Memberships' }, { value: 'Price' }],
  [{ value: 'JD-800 Model Expansion (for ZENOLOGY and JUPITER-X/Xm)' }, { value: 149 }],
  [{ value: 'JX-8P Model Expansion (for ZENOLOGY)' }, { value: 149 }],
  [{ value: 'SH-101 Model Expansion (for ZENOLOGY)' }, { value: 149 }],
  [{ value: 'JUNO-106 Model Expansion (for ZENOLOGY)' }, { value: 149 }],
  [{ value: 'JUPITER-8 Model Expansion (for ZENOLOGY)' }, { value: 149 }],
];

export const SOUND_PACKS_TABLE = [
  [{ value: 'Products' }, { value: 'Price' }],
  [{ value: 'SDZ Collections' }, { value: '$0.99 Each' }],
  [{ value: 'Model Expansion Sound Packs' }, { value: '$19.99 Each' }],
];

export const WAVE_EXPANSIONS_TABLE = [
  [{ value: 'Products' }, { value: 'Price' }],
  [{ value: 'EXZ Collections' }, { value: '$19.99 Each' }],
];

export const VIRTUAL_PERPETUAL_TABLE = [
  [{ value: 'Products' }, { value: 'Price' }],
  [{ value: 'ZENOLOGY Pro' }, { value: 229 }],
  [{ value: 'D-50' }, { value: 149 }],
  [{ value: 'JUNO-60' }, { value: 149 }],
  [{ value: 'TR-606' }, { value: 149 }],
  [{ value: 'JUNO-106' }, { value: 149 }],
  [{ value: 'JUPITER-8' }, { value: 149 }],
  [{ value: 'TR-909' }, { value: 149 }],
  [{ value: 'JX-3P' }, { value: 129 }],
  [{ value: 'TB-303' }, { value: 149 }],
  [{ value: 'JV-1080' }, { value: 129 }],
  [{ value: 'XV-5080' }, { value: 129 }],
  [{ value: 'System-8' }, { value: 129 }],
  [{ value: 'System-1' }, { value: 99 }],
  [{ value: 'Promars' }, { value: 99 }],
  [{ value: 'SH-101' }, { value: 99 }],
  [{ value: 'SH-2' }, { value: 99 }],
  [{ value: 'System-100' }, { value: 129 }],
  [{ value: 'Sound Canvas' }, { value: 69 }],
  [{ value: 'SRX Collection: 10 titles' }, { value: '$69 Each' }],
];
